import { DevHubBox, DevHubTypography } from '@devxdiscover/devhub-ui';
import { ChangesSummaryItem } from '../types';

interface ChangesSummaryProps {
  changes: ChangesSummaryItem[];
}

/**
 * Changes Summary Component
 * @param param0 - The props for the component
 * @returns The rendered component
 */
const ChangesSummary = ({ changes }: ChangesSummaryProps) => {
  return (
    <DevHubBox
      style={{
        marginTop: '2rem',
        padding: '1rem',
        backgroundColor: '#f5f5f5',
        borderRadius: '4px',
      }}
    >
      <DevHubTypography variant="h6" style={{ marginBottom: '1rem' }}>
        Data Lead Assignment Actions
      </DevHubTypography>

      {/* Changes Summary */}
      {changes.length > 0 ? (
        <DevHubBox
          style={{
            marginBottom: '1rem',
            padding: '1rem',
            backgroundColor: '#fff3cd',
            borderRadius: '4px',
          }}
        >
          <DevHubTypography
            variant="subtitle2"
            style={{ marginBottom: '0.5rem', fontWeight: 'bold' }}
          >
            Pending Changes ({changes.length} application
            {changes.length !== 1 ? 's' : ''}):
          </DevHubTypography>
          {changes.slice(0, 5).map(change => (
            <DevHubBox
              key={change.applicationId}
              style={{ marginBottom: '0.5rem' }}
            >
              <DevHubTypography variant="body2" style={{ fontWeight: 'bold' }}>
                {change.applicationName}:
              </DevHubTypography>
              {change.changes.map(
                (
                  ch: {
                    action: 'added' | 'removed';
                    leadLogin: string;
                    leadName: string;
                  },
                  idx: number,
                ) => (
                  <DevHubTypography
                    key={idx}
                    variant="caption"
                    style={{
                      display: 'block',
                      marginLeft: '1rem',
                      color: ch.action === 'added' ? '#2e7d32' : '#d32f2f',
                    }}
                  >
                    {ch.action === 'added' ? '+ ' : '- '}
                    {ch.leadName}
                  </DevHubTypography>
                ),
              )}
            </DevHubBox>
          ))}
          {changes.length > 5 && (
            <DevHubTypography variant="caption" style={{ color: '#666' }}>
              ... and {changes.length - 5} more applications with changes
            </DevHubTypography>
          )}
        </DevHubBox>
      ) : (
        <DevHubBox
          style={{
            marginBottom: '1rem',
            padding: '1rem',
            backgroundColor: '#e8f5e8',
            borderRadius: '4px',
          }}
        >
          <DevHubTypography variant="body2" style={{ color: '#2e7d32' }}>
            ✓ No changes made yet. Use the checkboxes above to assign/unassign
            data leads.
          </DevHubTypography>
        </DevHubBox>
      )}
    </DevHubBox>
  );
};

export default ChangesSummary;
